<template>
  <v-tooltip bottom>
    <template #activator="{on}">
      <v-btn :disabled="$store.getters['Ajax/loading']" v-on="on" text icon @click="click()">
        <v-icon>{{ actionItem.icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $t("components.actionButtons." + actionItem.tooltip.replace(/[."\s]/g, "")) }}</span>
  </v-tooltip>
</template>

<script>
import submitDelegationOrder from "./Repo/DelegationOrder/submitDelegationOrder";
import deleteDelegationOrder from "./Repo/DelegationOrder/deleteDelegationOrder";
import backStatusDelegationOrder from "./Repo/DelegationOrder/backStatusDelegationOrder";
import acceptDelegationOrder from "./Repo/DelegationOrder/acceptDelegationOrder";
import submitDelegation from "./Repo/Delegation/submitDelegation";
import acceptDelegation from "./Repo/Delegation/acceptDelegation";
import backStatusDelegation from "./Repo/Delegation/backStatusDelegation";
import settleDelegation from "./Repo/Delegation/settleDelegation";
import deleteDelegation from "./Repo/Delegation/deleteDelegation";
import editDelegation from "./Repo/Delegation/editDelegation";
import editDelegationOrder from "./Repo/DelegationOrder/editDelegationOrder";
import fileDownload from "../../repository/downloadFile";
import decisionDelegation from "./Repo/Delegation/decisionDelegation";
import decisionDelegationOrder from "./Repo/DelegationOrder/decisionDelegationOrder";
import cancelDelegationOrder from "./Repo/DelegationOrder/cancelDelegationOrder";
import cancelDelegation from "./Repo/Delegation/cancelDelegation";
import readonlyDelegation from "./Repo/Delegation/readonlyDelegation";
import readonlyDelegationOrder from "./Repo/DelegationOrder/readonlyDelegationOrder";

export default {
  name: "ActionItem",
  props: {
    actionItem: {
      required: true,
      type: Object
    },
    contextItemId: {
      default: null
    }
  },
  data: () => ({}),

  methods: {
    click: function() {
      //alert(JSON.stringify(this.actionItem));
      //alert(JSON.stringify(this.contextItemId));

      if (this.actionItem.type === "download") {
        fileDownload(this.actionItem.parameters.url);
      } else if (this.actionItem.type === "button") {
        if (this.actionItem.action === "deleteDelegationOrder") {
          deleteDelegationOrder(this);
        } else if (this.actionItem.action === "submitDelegationOrder") {
          submitDelegationOrder(this);
        } else if (this.actionItem.action === "backStatusDelegationOrder") {
          backStatusDelegationOrder(this);
        } else if (this.actionItem.action === "cancelDelegationOrder") {
          cancelDelegationOrder(this);
        } else if (this.actionItem.action === "acceptDelegationOrder") {
          acceptDelegationOrder(this);
        } else if (this.actionItem.action === "submitDelegation") {
          submitDelegation(this);
        } else if (this.actionItem.action === "backStatusDelegation") {
          backStatusDelegation(this);
        } else if (this.actionItem.action === "cancelDelegation") {
          cancelDelegation(this);
        } else if (this.actionItem.action === "acceptDelegation") {
          acceptDelegation(this);
        } else if (this.actionItem.action === "settleDelegation") {
          settleDelegation(this);
        } else if (this.actionItem.action === "deleteDelegation") {
          deleteDelegation(this);
        }
      } else if (this.actionItem.type === "form") {
        if (this.actionItem.action === "editDelegationOrder") {
          editDelegationOrder(this);
        } else if (this.actionItem.action === "readonlyDelegationOrder") {
          readonlyDelegationOrder(this);
        } else if (this.actionItem.action === "reviewAndAcceptDelegationOrder") {
          alert("TODO REVIED AND ACCEPT/DECLINE");
        } else if (this.actionItem.action === "editDelegation") {
          editDelegation(this);
        } else if (this.actionItem.action === "readonlyDelegation") {
          readonlyDelegation(this);
        } else if (this.actionItem.action === "decisionDelegation") {
          decisionDelegation(this);
        } else if (this.actionItem.action === "decisionDelegationOrder") {
          decisionDelegationOrder(this);
        }
      }
    }
  }
};
</script>

<style scoped></style>
